import {SocialDTO} from '../dto/social-dto';
import {Serializeable} from '../interfaces/serializeable';
import {SocialType} from '../enums/social-type';

const iconNames: Record<SocialType, string> = {
  [SocialType.FACEBOOK]: 'tablerBrandFacebook',
  [SocialType.INSTAGRAM]: 'tablerBrandInstagram',
  [SocialType.X]: 'tablerBrandX',
  [SocialType.LINKEDIN]: 'tablerBrandLinkedin',
  [SocialType.YOUTUBE]: 'tablerBrandYoutube',
  [SocialType.TIKTOK]: 'tablerBrandTiktok',
  [SocialType.MASTODON]: 'tablerBrandMastodon',
  [SocialType.BLUESKY]: 'tablerBrandBluesky',
};

export class Social extends Serializeable<SocialDTO> {
  private readonly _type: SocialType;
  private readonly _link: string;

  constructor(data: SocialDTO) {
    super();
    this._type = data.type;
    this._link = data.link;
  }

  get type(): SocialType {
    return this._type;
  }

  get link(): string {
    return this._link;
  }

  get iconName(): string | null {
    return iconNames[this._type] ?? null;
  }

  getDTO(): SocialDTO {
    return {
      type: this._type,
      link: this._link,
    };
  }
}
